import { render, staticRenderFns } from "./PaginationText.vue?vue&type=template&id=988808da"
import script from "./PaginationText.vue?vue&type=script&lang=js"
export * from "./PaginationText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports